import { render, staticRenderFns } from "./home-btn-factory.vue?vue&type=template&id=5c3032d8"
import script from "./home-btn-factory.vue?vue&type=script&lang=js"
export * from "./home-btn-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports